import { useEffect, useRef } from 'react';
import { shallowEqual } from '@src/utils/shallowEqual';
function useShallowCompareMemoize(value) {
    const ref = useRef();
    if (!shallowEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
/** useEffect but shallow compares items in the dependency list. */
export function useShallowCompareEffect(callback, dependencies) {
    // This special setup doesn't work well with the exhaustive-deps eslint check.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, dependencies.map(useShallowCompareMemoize));
}
